export default __webpack_public_path__ + "static/gs-3-publishmodel-e13314900913ee2a597ecebe10218014.jpg";